import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import 'react-datepicker/dist/react-datepicker.css';
import MonthDatePicker from 'components/shared/MonthDatePickerNew';
import { getSFTime } from 'services/formatDateToTimezone/formatDateToTimezone';
import moment from 'moment';
import styles from './styles.module.css';
import { Modal, Box } from '@material-ui/core';
import Text from 'components/shared/Text';
import { mailIcon } from 'assets/newIcons';
import DateRangePickerMonth from 'components/shared/DateRangePickerMonth';

const boxStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  padding: '20px 40px 40px 20px',
  boxShadow: 24,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '30px',
  height: '180px',
  width: '320px',
};

const StatementsHeader = ({ statementProps }) => {
  const { loadStatement, isDownload, user } = statementProps;
  const sfDate = getSFTime();
  const [date, setDate] = useState(sfDate);
  const [open, setOpen] = useState(false);
  const [loading, setloading] = useState(false);

  const [openAppStoreQRCode, setOpenAppStoreQRCode] = React.useState(false);
  const handleCloseAppStoreQRCode = () => setOpenAppStoreQRCode(false);

  useEffect(() => {
    if (isDownload === true) {
      setOpenAppStoreQRCode(true);
      setloading(false);
    } else if (isDownload === false) {
      setOpenAppStoreQRCode(false);
      setOpen(false);
    }
  }, [isDownload]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <h1 className={styles.statementHeading}>Statements</h1>

        <div className={styles.pickHistoryDate}>
          <DateRangePickerMonth
            open={open}
            setOpen={setOpen}
            loading={loading}
            setloading={setloading}
            initialDate={date}
            isStatement
            secondaryAction={d => {
              setDate(d);
              loadStatement({
                email: user?.email,
                type: 'individual',
                dates: [ moment(d).format('YYYY-MM') ],
              });
            }}
          />
        </div>
      </div>
      <Modal open={openAppStoreQRCode} onClose={handleCloseAppStoreQRCode}>
        <Box sx={boxStyle}>
          <img alt='' width={80} height={80} src={mailIcon} />
          <Text className={styles.imgHeading}>
            Your statements have <br /> been sent to your <br /> email.
          </Text>
        </Box>
      </Modal>
    </div>
  );
};
StatementsHeader.propTypes = {
  statementProps: PropTypes.object.isRequired,
};

export default StatementsHeader;
